import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/layout/layout.component').then(module => module.LayoutComponent),
        children: [
            {
                path: '',
                loadComponent: () => import('src/app/front/views/home/home.component').then(module => module.HomeComponent),
                data: {
                    path: 'home'
                }
            },
            {
                path: $localize`:@@pathFrontAbout:o-nas`,
                loadComponent: () => import('src/app/front/views/about/about.component').then(module => module.AboutComponent),
                data: {
                    path: 'about'
                }
            },
            {
                path: $localize`:@@pathFrontOffer:oferta`,
                loadComponent: () => import('src/app/front/views/offer/offer.component').then(module => module.OfferComponent),
                data: {
                    path: 'offer'
                }
            },
            {
                path: $localize`:@@pathFrontCatalog:katalog`,
                loadComponent: () => import('src/app/front/views/catalog/catalog.component').then(module => module.CatalogComponent),
                data: {
                    path: 'catalog'
                }
            },
            {
                path: $localize`:@@pathFrontContact:kontakt`,
                loadComponent: () => import('src/app/front/views/contact/contact.component').then(module => module.ContactComponent),
                data: {
                    path: 'contact'
                }
            },
            {
                path: $localize`:@@pathFrontPolicyPrivacy:polityka-prywatnosci`,
                loadComponent: () => import('src/app/front/views/policy-privacy/policy-privacy.component').then(module => module.PolicyPrivacyComponent),
                data: {
                    path: 'policy-privacy'
                }
            },
            {
                path: $localize`:@@pathFrontNews:aktualnosci`,
                loadComponent: () => import('src/app/front/views/news/news.component').then(module => module.NewsComponent),
                data: {
                    path: 'news'
                }
            },
            {
                path: ':offer',
                loadComponent: () => import('src/app/front/views/offer/offer.component').then(module => module.OfferComponent),
                data: {
                    path: 'offer'
                },
            },
            {
                path: '**',
                redirectTo: '',
            }
        ],
    },
];
